module.exports = __webpack_public_path__ + "static/media/recommendation8.f3526846.jpg";